module.exports = __webpack_public_path__ + "static/Tube Night-eb3c5487aa536320b29c2961c35d2550.png";